"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  NavigationMenu1: ['navigation-menu-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3.000 3.000 L21.000 3.000 L21.000 7.000 L3.000 7.000 Z', 'M3.000 10.000 L21.000 10.000 L21.000 14.000 L3.000 14.000 Z', 'M3.000 17.000 L21.000 17.000 L21.000 21.000 L3.000 21.000 Z']],
  NavigationMenu3Alternate: ['navigation-menu-3-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z', 'M16.5,11h-9a1,1,0,0,0,0,2h9a1,1,0,0,0,0-2Z', 'M16.5,15h-9a1,1,0,0,0,0,2h9a1,1,0,0,0,0-2Z', 'M16.5,7h-9a1,1,0,0,0,0,2h9a1,1,0,0,0,0-2Z']],
  NavigationMenu: ['navigation-menu', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0.500 2.500 L23.500 2.500 L23.500 5.500 L0.500 5.500 Z', 'M0.500 10.500 L23.500 10.500 L23.500 13.500 L0.500 13.500 Z', 'M0.500 18.500 L23.500 18.500 L23.500 21.500 L0.500 21.500 Z']],
  NavigationMenuHorizontal2Alternate: ['navigation-menu-horizontal-2-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.001 12.000 A2.000 2.000 0 1 0 14.001 12.000 A2.000 2.000 0 1 0 10.001 12.000 Z', 'M15.501 12.000 A2.000 2.000 0 1 0 19.501 12.000 A2.000 2.000 0 1 0 15.501 12.000 Z', 'M4.501 12.000 A2.000 2.000 0 1 0 8.501 12.000 A2.000 2.000 0 1 0 4.501 12.000 Z', 'M21,24H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H21a3,3,0,0,1,3,3V21A3,3,0,0,1,21,24ZM3,2A1,1,0,0,0,2,3V21a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1Z']],
  NavigationMenuHorizontal1: ['navigation-menu-horizontal-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0ZM8.5,12a2,2,0,1,1-2-2A2,2,0,0,1,8.5,12ZM12,10a2,2,0,1,1-2,2A2,2,0,0,1,12,10Zm5.5,4a2,2,0,1,1,2-2A2,2,0,0,1,17.5,14Z']],
  NavigationMenu3: ['navigation-menu-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0ZM7.5,15h9a1,1,0,0,1,0,2h-9a1,1,0,0,1,0-2Zm-1-3a1,1,0,0,1,1-1h9a1,1,0,0,1,0,2h-9A1,1,0,0,1,6.5,12Zm10-3h-9a1,1,0,0,1,0-2h9a1,1,0,0,1,0,2Z']],
  NavigationMenu4Alternate: ['navigation-menu-4-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,11H6.5a1,1,0,0,0,0,2h11a1,1,0,0,0,0-2Z', 'M17.5,15H6.5a1,1,0,0,0,0,2h11a1,1,0,0,0,0-2Z', 'M17.5,7H6.5a1,1,0,0,0,0,2h11a1,1,0,0,0,0-2Z', 'M21,0H3A3,3,0,0,0,0,3V21a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V3A3,3,0,0,0,21,0Zm1,21a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V3A1,1,0,0,1,3,2H21a1,1,0,0,1,1,1Z']],
  NavigationMenuVertical: ['navigation-menu-vertical', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.750 3.250 A3.250 3.250 0 1 0 15.250 3.250 A3.250 3.250 0 1 0 8.750 3.250 Z', 'M8.750 12.000 A3.250 3.250 0 1 0 15.250 12.000 A3.250 3.250 0 1 0 8.750 12.000 Z', 'M8.750 20.750 A3.250 3.250 0 1 0 15.250 20.750 A3.250 3.250 0 1 0 8.750 20.750 Z']],
  NavigationMenu4: ['navigation-menu-4', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM17.5,17H6.5a1,1,0,0,1,0-2h11a1,1,0,0,1,0,2Zm0-4H6.5a1,1,0,0,1,0-2h11a1,1,0,0,1,0,2Zm0-4H6.5a1,1,0,0,1,0-2h11a1,1,0,0,1,0,2Z']],
  NavigationMenuHorizontal1Alternate: ['navigation-menu-horizontal-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z', 'M10.000 12.000 A2.000 2.000 0 1 0 14.000 12.000 A2.000 2.000 0 1 0 10.000 12.000 Z', 'M15.500 12.000 A2.000 2.000 0 1 0 19.500 12.000 A2.000 2.000 0 1 0 15.500 12.000 Z', 'M4.500 12.000 A2.000 2.000 0 1 0 8.500 12.000 A2.000 2.000 0 1 0 4.500 12.000 Z']],
  NavigationMenuHorizontal: ['navigation-menu-horizontal', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0.000 12.000 A3.250 3.250 0 1 0 6.500 12.000 A3.250 3.250 0 1 0 0.000 12.000 Z', 'M8.750 12.000 A3.250 3.250 0 1 0 15.250 12.000 A3.250 3.250 0 1 0 8.750 12.000 Z', 'M17.500 12.000 A3.250 3.250 0 1 0 24.000 12.000 A3.250 3.250 0 1 0 17.500 12.000 Z']],
  NavigationMenu2: ['navigation-menu-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.000 3.000 L24.000 3.000 L24.000 7.000 L6.000 7.000 Z', 'M3.000 10.000 L21.000 10.000 L21.000 14.000 L3.000 14.000 Z', 'M0.000 17.000 L18.000 17.000 L18.000 21.000 L0.000 21.000 Z']],
  NavigationMenuHorizontal2: ['navigation-menu-horizontal-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0ZM6.5,14a2,2,0,1,1,2-2A2,2,0,0,1,6.5,14ZM12,14a2,2,0,1,1,2-2A2,2,0,0,1,12,14Zm5.5,0a2,2,0,1,1,2-2A2,2,0,0,1,17.5,14Z']]
};
exports["default"] = _default;